package com.dotdrives.web.pages.settings

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

val SettingsManagementStyles = FC<Props> {
    style { +"""
        .settings-management-dialog { box-sizing:border-box; max-height:calc(100dvh - 32px); overflow-y:auto; }
        .settings-management-dialog .settings-form-grid > *, .settings-management-dialog .settings-form-field { min-width:0; }
        .settings-management-dialog input, .settings-management-dialog select { min-width:0; box-sizing:border-box; max-width:100%; width:100%; }
        .settings-management-dialog .settings-tag-color-row { flex-wrap:wrap; }
        .settings-management-dialog .settings-tag-swatch { flex-shrink:0; color:#fff; font-size:20px; text-shadow:0 1px 3px #222; }
        .settings-management-dialog .settings-dialog-actions { gap:8px; }
        .settings-management-dialog .settings-dialog-actions > * { white-space:nowrap; min-height:44px; }
        .settings-management-row { display:flex; align-items:center; flex-wrap:wrap; gap:12px; border-top:1px solid #e4e8ea; padding:16px 0; width:100%; }
        .settings-management-row-actions { display:flex; gap:8px; flex-wrap:nowrap; }
        .settings-management-row-actions .dot-button { margin:0; }
        .settings-section-card .settings-management-row-title { font-size:18px; }
        .settings-management-identity { flex:1 1 260px; overflow-wrap:anywhere; }
        .settings-management-feedback { background:#eaf5ec; color:#225c32; padding:12px 16px; border-radius:10px; margin-bottom:16px; }
        .settings-management-preview { padding:12px 0; overflow-wrap:anywhere; }
        .settings-management-primary { min-height:44px; border-radius:24px; padding:10px 20px; background:#F26223; color:#222D32; font:inherit; font-weight:800; cursor:pointer; }
        @media(max-width:420px) {
          .settings-management-dialog { padding:20px; width:calc(100vw - 24px); }
          .settings-management-dialog .settings-form-grid { grid-template-columns:minmax(0,1fr); }
          .settings-management-dialog .settings-dialog-actions > * { padding-left:14px; padding-right:14px; }
        }
    """ }
}
